import React from 'react';
import Header from './widgets/Header';
import SurveyImage1 from '../../../assets/images/survey-image-1.png'
import SurveyImage2 from '../../../assets/images/survey-image-2.png'
import Media from './widgets/Media';
import Svg from '../Svg';

export default function SimpleLandingPage() {
    return (
        <div className='d-flex flex-column landing-page-wrapper'>
            <Header />
            <div className="flex-grow-1 main-content-wrap">
                <div className="banner-section">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5">
                                <div className="banner-text">
                                    <h1 className='heading fs-48 fw-700'>Check <span className='text-primary'>Digital Maturity</span> across 8 dimensions through our assessment.</h1>
                                    <div className="text-part">
                                        <p>Tempor elementum est sed imperdiet. Integer</p>
                                    </div>
                                    <div className="button-wrap">
                                        <a href="#0" className='btn btn-primary'>Start assessment <Svg name="right-arrow" /></a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="img-wrapper">
                                    <Media imageUrl={SurveyImage1} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content-section section-padding right-media">
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-lg-5">
                                <div className="text-wrap">
                                    <h2 className='heading fs-38 fw-700'>About our <span className='text-primary'>Digital Maturity Survey</span></h2>
                                    <div className="text-part">
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras tempor elementum est sed imperdiet. Integer </p>
                                    </div>
                                    <div className="listing-section">
                                        <div className="list-wrap d-flex">
                                            <div className="icon-wrap purple">
                                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 12.2H15" stroke="white" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M8 16.2H12.38" stroke="white" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z" stroke="white" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M16 4.01999C19.33 4.19999 21 5.42999 21 9.99999V16C21 20 20 22 15 22H9C4 22 3 20 3 16V9.99999C3 5.43999 4.67 4.19999 8 4.01999" stroke="white" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <div className="flex-grow-1 list-text">
                                                <h4>Personalized reports</h4>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras tempor elementum est sed imperdiet. Integer </p>
                                            </div>
                                        </div>
                                        <div className="list-wrap d-flex">
                                            <div className="icon-wrap success">
                                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.0901 13.28H9.1801V20.48C9.1801 22.16 10.0901 22.5 11.2001 21.24L18.7701 12.64C19.7001 11.59 19.3101 10.72 17.9001 10.72H14.8101V3.52C14.8101 1.84 13.9001 1.5 12.7901 2.76L5.2201 11.36C4.3001 12.42 4.6901 13.28 6.0901 13.28Z" stroke="white" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <div className="flex-grow-1 list-text">
                                                <h4>Quick and easy </h4>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras tempor elementum est sed imperdiet. Integer </p>
                                            </div>
                                        </div>
                                        <div className="list-wrap d-flex">
                                            <div className="icon-wrap warning">
                                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M18.4698 16.83L18.8598 19.99C18.9598 20.82 18.0698 21.4 17.3598 20.97L13.1698 18.48C12.7098 18.48 12.2599 18.45 11.8199 18.39C12.5599 17.52 12.9998 16.42 12.9998 15.23C12.9998 12.39 10.5398 10.09 7.49985 10.09C6.33985 10.09 5.26985 10.42 4.37985 11C4.34985 10.75 4.33984 10.5 4.33984 10.24C4.33984 5.68999 8.28985 2 13.1698 2C18.0498 2 21.9998 5.68999 21.9998 10.24C21.9998 12.94 20.6098 15.33 18.4698 16.83Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M13 15.23C13 16.42 12.56 17.52 11.82 18.39C10.83 19.59 9.26 20.36 7.5 20.36L4.89 21.91C4.45 22.18 3.89 21.81 3.95 21.3L4.2 19.33C2.86 18.4 2 16.91 2 15.23C2 13.47 2.94 11.92 4.38 11C5.27 10.42 6.34 10.09 7.5 10.09C10.54 10.09 13 12.39 13 15.23Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>

                                            </div>
                                            <div className="flex-grow-1 list-text">
                                                <h4>Consultation and suggestions</h4>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras tempor elementum est sed imperdiet. Integer </p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 offset-lg-1">
                                <div className="img-wrapper rounded-8">
                                    <Media imageUrl={SurveyImage2} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content-section section-padding no-media text-center">
                    <div className="container">
                        <div className="text-wrap">
                            <h3 className='heading fs-48 fw-600'>Start your survey now</h3>
                            <div className="text-part">
                                <p className='fs-20'>The assessment contains 23 questions separated into three sections and takes around 15 minUTes to complete. At the end of the review, you will gain crucial and actionable insights to help you embed the right security and management controls to embrace many future.</p>
                            </div>
                            <div className="button-wrap">
                                <a href="#0" className='btn btn-primary'>Start assessment <Svg name="right-arrow" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
